import * as icon from "@fluentui/react-northstar";
import * as React from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { getSelectedProductInformation } from "../../../../Utilities/Product";
import { Card } from "./components/CardItem/CardItem";
import CustomHeader from "./components/Header/CustomHeader";
import CustomTMHeader from "./components/Header/CustomTMHeader";
import CustomEUMHeader from "./components/Header/CustomEUMHeader";
import Selection from "./components/Sections/Sections";
import TMCardItem from "./components/TMCardItem/TMCardItem";
import style from "./getStarted.module.scss";

interface GetStartedProps {
}

class GetStarted extends React.Component<
  GetStartedProps & WrappedComponentProps
> {
  render() {
    const title = getSelectedProductInformation().information.title;
    const isTMorEUM = title === "Teams Manager" || title === "External User Manager";

    return (
      <>
        {title === "Teams Manager" && <CustomTMHeader />}
        {title === "External User Manager" && <CustomEUMHeader />}
        {!isTMorEUM && <CustomHeader />}

        {isTMorEUM ? (
          <div className={style.cardContainer}>
            {getSelectedProductInformation().getStarted.cardData.map((cardItem: any, index: number) => (
              <TMCardItem
                key={index}
                image={cardItem.image}
                title={cardItem.title}
                description={cardItem.description}
                link={cardItem.link}
              />
            ))}
          </div>
        ) : (
          <>
            <div className={style.informationContainer}>
              {getSelectedProductInformation().getStarted.specifications.map((data, index) => {
                const Icon = icon?.[data.icon];
                return (
                  <Card
                    key={index}
                    translationHeaderID={data.title}
                    translationTextID={data.text}
                    title={data.altTitle}
                    text={data.altText}
                    icon={<Icon outline />}
                  />
                );
              })}
            </div>
            <div className={style.selectionContainer}>
              <Selection />
            </div>
          </>
        )}
      </>
    );
  }
}

export default injectIntl(GetStarted);
